import React, { ReactElement } from 'react'

import sortOptionsConfig, {
  RecipeSortId,
} from '@mindfulchefuk/config/sortOptionsConfig'
import {
  Box,
  Dropdown,
  Flex,
  Icon,
  ResetButton,
  Text,
} from '@mindfulchefuk/design-system'

import { OnboardingChooseRecipesSortRadioButtons } from './OnboardingChooseRecipesSortRadioButtons'
import { TOnboardingRecipeFilterHandlers } from '../OnboardingRecipeFilterHandlers.types'

type TOnboardingChooseRecipesSortFilter = {
  onChange: TOnboardingRecipeFilterHandlers['sortBy']
  onToggle: () => void
  isOpen: boolean
  recipesSortedBy: RecipeSortId
}

export const OnboardingChooseRecipesSortFilter = ({
  onChange,
  onToggle,
  isOpen,
  recipesSortedBy,
}: TOnboardingChooseRecipesSortFilter): ReactElement => {
  const label = sortOptionsConfig.find(
    ({ id }) => id === recipesSortedBy
  )?.title

  return (
    <Box position="relative" id="sort-by-filter">
      <ResetButton
        display="block"
        data-testid="recipe-filter-sort-by"
        onClick={() => {
          onToggle()
        }}
      >
        <Flex color="aubergine">
          <Icon type="sort" flexShrink={0} mr={8} />
          <Text
            variant="body-sm-500-caps"
            as="span"
            color="aubergine"
            data-testid="sort-by-label"
          >
            {label}
          </Text>
          <Icon ml={10} type={isOpen ? 'chevron-up' : 'chevron-down'} />
        </Flex>
      </ResetButton>
      <Dropdown
        onToggle={onToggle}
        isOpen={isOpen}
        alignment={{ base: 'left', sm: 'right' }}
        width={224}
      >
        <OnboardingChooseRecipesSortRadioButtons
          onChange={onChange}
          recipesSortedBy={recipesSortedBy}
        />
      </Dropdown>
    </Box>
  )
}
